import { Container, Row, Col, Card } from 'react-bootstrap';

const Safety = () => {
  const safetyTips = [
    {
      icon: 'bi-shield-lock',
      title: 'Protect Your Personal Information',
      tips: [
        'Never share your home address, workplace, or financial information',
        'Use Paperdate messaging instead of giving out your phone number early',
        'Be cautious about sharing your full name until you feel comfortable',
        'Don\'t share passwords or login credentials with anyone'
      ]
    },
    {
      icon: 'bi-geo-alt',
      title: 'Meeting in Person',
      tips: [
        'Always meet in a public place for your first few dates',
        'Tell a friend or family member where you\'re going and who you\'re meeting',
        'Arrange your own transportation to and from the date',
        'Stay sober and alert during your first meetings'
      ]
    },
    {
      icon: 'bi-exclamation-triangle',
      title: 'Recognizing Red Flags',
      tips: [
        'Be wary of anyone who asks for money or financial help',
        'Watch out for inconsistent stories or evasive answers',
        'Trust your instincts if something feels off',
        'Be cautious of people who want to move the relationship too quickly'
      ]
    },
    {
      icon: 'bi-telephone',
      title: 'Video Chat First',
      tips: [
        'Use video calls to verify the person matches their photos',
        'Pay attention to their background and behavior during calls',
        'A video chat can help you gauge chemistry before meeting',
        'If they refuse to video chat, consider it a warning sign'
      ]
    }
  ];

  return (
    <Container className="py-5">
      <Row className="justify-content-center mb-5">
        <Col lg={8} className="text-center">
          <h1 className="display-4 fw-bold mb-4">Safety Tips</h1>
          <p className="lead text-muted">
            Your safety is our priority. Follow these guidelines to have a safe and enjoyable dating experience.
          </p>
        </Col>
      </Row>

      <Row className="mb-5">
        <Col>
          <Card className="border-0 shadow-sm bg-dark text-white">
            <Card.Body className="p-4 p-lg-5 text-center">
              <i className="bi bi-shield-check display-4 mb-3"></i>
              <h3 className="fw-bold mb-3">Your Safety Matters</h3>
              <p className="mb-0">
                Online dating should be fun and exciting. By following these safety tips, 
                you can protect yourself while finding meaningful connections.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        {safetyTips.map((section, index) => (
          <Col lg={6} key={index} className="mb-4">
            <Card className="border-0 shadow-sm h-100">
              <Card.Body className="p-4">
                <h4 className="fw-bold mb-4">
                  <i className={`bi ${section.icon} text-primary me-2`}></i>
                  {section.title}
                </h4>
                <ul className="list-unstyled mb-0">
                  {section.tips.map((tip, tipIndex) => (
                    <li key={tipIndex} className="mb-3 d-flex">
                      <i className="bi bi-check-circle-fill text-primary me-2 mt-1"></i>
                      <span className="text-muted">{tip}</span>
                    </li>
                  ))}
                </ul>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <Row className="mt-5">
        <Col>
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-4">
              <h4 className="fw-bold mb-3">
                <i className="bi bi-flag text-primary me-2"></i>
                Report Suspicious Behavior
              </h4>
              <p className="text-muted mb-0">
                If you encounter suspicious behavior, harassment, or feel unsafe, please report it immediately. 
                Use the report button on any profile or message, or contact us at{' '}
                <a href="mailto:safety@paperdate.io" className="text-primary">safety@paperdate.io</a>. 
                We take all reports seriously and respond within 24 hours.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Safety;

